<template>
  <div class="btns">
    <div v-for="(item, idx) in chatButtons" :key="idx" @click="clickedCategory(item, messageType, chatIndex, chat)">
      <a
        v-show="item.type !== 'COUNSELOR_BUTTON' && item.type !== 'URL_BUTTON' && item.type !== 'TEL_BUTTON'"
        :class="{ on: scenarioData[chatIndex] === item.code }"
      >
        {{ item.url }} {{ messageType === 'SCENARIO' ? item.text : item.data }}
        <i class="UXicon-arrow_right" v-if="item.type === 'LINK_BUTTON'"></i>
      </a>

      <a
        v-if="item.type !== 'COUNSELOR_BUTTON' && item.type === 'URL_BUTTON' && item.url"
        :href="item.url"
        target="_blank"
        :class="{ on: scenarioData[chatIndex] === item.code }"
      >
        {{ messageType === 'SCENARIO' ? item.text : item.data }}
        <i class="UXicon-link"></i>
      </a>

      <a
        v-if="item.type !== 'COUNSELOR_BUTTON' && item.type === 'TEL_BUTTON' && item.callNumber"
        :href="`tel:${item.callNumber}`"
        target="_blank"
        :class="{ on: scenarioData[chatIndex] === item.code }"
      >
        {{ messageType === 'SCENARIO' ? item.text : item.data }}
        <i class="UXicon-call"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonContents',
  props: ['chatIndex', 'messageType', 'clickedCategory', 'chatButtons', 'scenarioData', 'chat']
};
</script>
